<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">{{this.$route.name}}</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.member_id)" class="btn-grey">
              <i class="fas fa-arrow-circle-left mr-5"></i>Back
            </a>
          </div>
          <div class="col-md-6 text-right"></div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitData">
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="9" md="10">
                  <b-form-select
                    class="w-100"
                    name="personal_trainer"
                    v-validate="'required'"
                    v-model="editData.personal_trainer_id"
                  >
                    <option :value="null">Please select</option>
                    <option
                      v-for="listItem in itemPt"
                      :key="listItem.id"
                      :value="listItem.id"
                    >{{listItem.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Gross Amount</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    v-model="editData.gross_amount"
                    name="gross_amount"
                    v-validate="'required|decimal:2'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('gross_amount') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Personal Trainer Comission</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    v-model="editData.personal_trainer_comission"
                    name="personal_trainer_comission"
                    v-validate="'required|decimal:2'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('personal_trainer_comission') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT Session Price</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    v-model="editData.pt_session_price"
                    name="pt_session_price"
                    v-validate="'required|decimal:2'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('pt_session_price') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Created At</label>
                </b-col>
                <b-col sm="9" md="10">
                  <flat-pickr
                    :config="config"
                    v-model="editData.created_at"
                    v-validate="'required'"
                    name="created_at"
                    class="w-100 border-bottom"
                  ></flat-pickr>
                  <span class="error">{{ errors.first('editData.created_at') }}</span>
                </b-col>
              </b-row>
              <div class="text-right mb-20">
                <button :disabled="disabledBtnSubmit" type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";

export default {
  name: "addPtSession",
  components: {
    "app-pagination": Pagination
  },
  data: function() {
    return {
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      itemPt: [],
      itemPtSession: [],
      itemListEdit: [],
      editData: {
        personal_trainer_id: "",
        gross_amount: "",
        personal_trainer_comission: "",
        pt_session_price: "",
        created_at: ""
      },
      config: {
        altInput: true,
        altFormat: "j F Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      config2: {
        altInput: true,
        altFormat: "j F Y",
        dateFormat: "Y-m-d",
        enableTime: false
      },
      disabledBtnSubmit: false
    };
  },
  methods: {
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    parseDate(event) {
      return moment(event).format("DD MMMM YYYY");
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .put(
              "fitness/v1/member_pt_session/running_session?id=" +
                this.$route.query.id,
              this.editData
            )
            .then(response => {
              this.$router.push(
                "/memberEntry/addPtSession?id=" +
                  this.$route.query.session_id +
                  "&member_id=" +
                  this.$route.query.member_id
              );
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              // console.log('error log', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    fetchData() {
      var today = moment().format('YYYY-MM-DD')
      axios
        .get("fitness/v1/personal_training/")
        .then(response => {
          this.itemPt = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "fitness/v1/member_pt_session/single_running?id=" +
            this.$route.query.id
        )
        .then(response => {
          const year = moment(response.data.data.created_at).format('YYYY')
          const month = moment(response.data.data.created_at).format('M')

          axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(response => {
            this.disabledBtnSubmit = true
          }).catch(error => {
            this.disabledBtnSubmit = false
            console.log('error', error)
          })
          
          this.editData.personal_trainer_id =
            response.data.data.personal_trainer_id;
          this.editData.gross_amount = response.data.data.gross_amount;
          this.editData.personal_trainer_comission =
            response.data.data.personal_trainer_comission;
          this.editData.pt_session_price = response.data.data.pt_session_price;
          this.editData.created_at = response.data.data.created_at;
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style>
</style>
